import React, { useState } from "react"
import {
    Card,
    CardBody,
    Table,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    NavItem,
    NavLink,
    Row,
    Button,
    TabContent,
    TabPane,
    FormFeedback,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,

} from "reactstrap"
import banner from "../../assets/images/banner/banner.jpg";
import { useHistory } from "react-router-dom";

const BranchHeader = () => {
    var authUserName = JSON.parse(localStorage.getItem('userName'));

    const [menu, setMenu] = useState(false);
    const [username, setusername] = useState(authUserName);
    const history = useHistory();

    return (
        <React.Fragment>
            <Row>
                <div style={{ width: "100%", backgroundColor: "#9a084f" }}>
                    <Row>
                        <Col lg="5">
                            <div >
                                <img className="img-fluid.max-width: 100%;height:auto" style={{ height: "70px" }} src={banner} alt="Banner" />
                            </div>
                        </Col>
                        <Col lg="4">
                            <div>
                                <label style={{ fontSize: "25px", color: "white", marginTop: "15px" }}>Online Account Application</label>
                            </div>
                        </Col>
                        <Col lg="3" style={{ textAlign: "right" }}>
                            <Dropdown
                                isOpen={menu}
                                toggle={() => setMenu(!menu)}
                                style={{ color: "white", fontSize: "large" }}
                            >
                                <DropdownToggle
                                    className="btn header-item "
                                    id="page-header-user-dropdown"
                                    tag="button"
                                    style={{ color: "white", fontSize: "large" }}
                                >
                                    <label style={{ fontSize: "15px", color: "white" }}>{username}</label>
                                    <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    <div className="dropdown-divider" />
                                    <button type="button" className="btn" style={{ color: "black", fontSize: "medium" }}
                                        onClick={() => {
                                            debugger;
                                            localStorage.clear();
                                            history.push('/BranchLogin');
                                        }} >
                                        <span className="bx bx-log-in" style={{ fontSize: "xx-large" }}></span> Logout
                                    </button>
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                    </Row>
                </div>
            </Row>
        </React.Fragment >
    );
};

export default BranchHeader


